const { getRandomizer } = require('../randomizers');
const { createExperimentSignature } = require('../export/report');

function normalizeVerificationInput(input) {
  if (typeof input === 'string') {
    return JSON.parse(input);
  }

  return input;
}

async function verifyRandomization(input) {
  const payload = normalizeVerificationInput(input);
  const technique = payload.technique || payload.algorithmId || payload.method;
  const expectedSignature = payload.expectedSignature || payload.experimentSignature || payload.signature;
  const seed = payload.seed
    || (payload.parameters && payload.parameters.seed)
    || (payload.normalizedParameters && payload.normalizedParameters.seed);
  const parameters = {
    ...(payload.parameters || payload.normalizedParameters || {}),
    technique,
    seed
  };

  if (!technique) {
    throw new Error('Verification requires a technique or algorithmId.');
  }

  if (!expectedSignature) {
    throw new Error('Verification requires an expected experiment signature.');
  }

  if (!seed) {
    throw new Error('Verification requires the original seed.');
  }

  const result = getRandomizer(technique).generate(parameters);
  if (payload.parameters && Object.prototype.hasOwnProperty.call(payload.parameters, 'technique')) {
    result.parameters.technique = payload.parameters.technique;
  } else {
    delete result.parameters.technique;
  }
  const actualSignature = await createExperimentSignature(result);
  const status = actualSignature === expectedSignature ? 'PASS' : 'FAIL';

  return {
    status,
    technique,
    expectedSignature,
    actualSignature,
    sequenceLength: result.sequence.length,
    message: status === 'PASS'
      ? 'Independent verification reproduced the expected signature.'
      : 'Independent verification did not match the expected signature.'
  };
}

module.exports = {
  normalizeVerificationInput,
  verifyRandomization
};
